export const DEFAULT_RANGES = [0, 50, 50, 75, 75, 100, null, null, null, null];

export const GRID_INTERVALS = [10, 20, 30, 40, 50, 60, 70, 80, 90];
